import React, { Component } from "react";

export default class Sidebar extends Component {
  render() {
    const currentPath = window.location.pathname;

    return (
      <div id="layoutSidenav_nav">
        <nav
          className="sb-sidenav accordion sb-sidenav-dark"
          id="sidenavAccordion"
          style={{
            height: "100vh",
            overflow: "hidden",
          }}
        >
          <div
            className="sb-sidenav-menu"
            style={{
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
              paddingBottom: "90px",
              scrollBehavior: "smooth",
              scrollbarWidth: "thin",
            }}
          >
            <div className="nav">

              {/* ================= DASHBOARD ================= */}
              <a
                className={`nav-link ${currentPath === "/admin" ? "active" : ""
                  }`}
                href="/"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt" />
                </div>
                Dashboard
              </a>

              {/* ================= PRODUCTS ================= */}
              <a
                className="nav-link collapsed"
                href="#"
                data-toggle="collapse"
                data-target="#collapseProducts"
                aria-expanded={
                  currentPath.includes("/admin/product") ? "true" : "false"
                }
                aria-controls="collapseProducts"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-box" />
                </div>
                Products
                <div className="sb-sidenav-collapse-arrow">
                  <i className="fas fa-angle-down" />
                </div>
              </a>

              <div
                className={`collapse ${currentPath.includes("/admin/product") ? "show" : ""
                  }`}
                id="collapseProducts"
              >
                <nav className="sb-sidenav-menu-nested nav">
                  <a
                    className={`nav-link sub_nav_link ${currentPath === "/admin/product/list" ? "active" : ""
                      }`}
                    href="/admin/product/list"
                  >
                    All Products
                  </a>

                  <a
                    className={`nav-link sub_nav_link ${currentPath === "/admin/product/create" ? "active" : ""
                      }`}
                    href="/admin/product/create"
                  >
                    Add Product
                  </a>
                </nav>
              </div>

              {/* ================= CATEGORIES ================= */}
              <a
                className="nav-link collapsed"
                href="#"
                data-toggle="collapse"
                data-target="#collapseCategories"
                aria-expanded={
                  currentPath.includes("/admin/category") ? "true" : "false"
                }
                aria-controls="collapseCategories"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-list" />
                </div>
                Categories
                <div className="sb-sidenav-collapse-arrow">
                  <i className="fas fa-angle-down" />
                </div>
              </a>

              <div
                className={`collapse ${currentPath.includes("/admin/category") ? "show" : ""
                  }`}
                id="collapseCategories"
              >
                <nav className="sb-sidenav-menu-nested nav">
                  <a
                    className={`nav-link sub_nav_link ${currentPath === "/admin/category/list" ? "active" : ""
                      }`}
                    href="/admin/category/list"
                  >
                    All Categories
                  </a>

                  <a
                    className={`nav-link sub_nav_link ${currentPath === "/admin/category/create" ? "active" : ""
                      }`}
                    href="/admin/category/create"
                  >
                    Add Category
                  </a>
                </nav>
              </div>

              {/* ================= USERS ================= */}
              <a
                className="nav-link collapsed"
                href="#"
                data-toggle="collapse"
                data-target="#collapseUsers"
                aria-expanded={
                  currentPath.includes("/admin/user") ? "true" : "false"
                }
                aria-controls="collapseUsers"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-user" />
                </div>
                Users
                <div className="sb-sidenav-collapse-arrow">
                  <i className="fas fa-angle-down" />
                </div>
              </a>

              <div
                className={`collapse ${currentPath.includes("/admin/user") ? "show" : ""
                  }`}
                id="collapseUsers"
              >
                <nav className="sb-sidenav-menu-nested nav">
                  <a
                    className={`nav-link sub_nav_link ${currentPath === "/admin/user/list" ? "active" : ""
                      }`}
                    href="/admin/user/list"
                  >
                    All Users
                  </a>

                  <a
                    className={`nav-link sub_nav_link ${currentPath === "/admin/user/create" ? "active" : ""
                      }`}
                    href="/admin/user/create"
                  >
                    Add User
                  </a>
                </nav>
              </div>

              {/* ================= FILE UPLOADS ================= */}
              <a
                className="nav-link collapsed"
                href="#"
                data-toggle="collapse"
                data-target="#collapseUploads"
                aria-expanded={
                  currentPath.includes("/admin/uploads") ? "true" : "false"
                }
                aria-controls="collapseUploads"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-file-archive" />
                </div>
                File Uploads
                <div className="sb-sidenav-collapse-arrow">
                  <i className="fas fa-angle-down" />
                </div>
              </a>

              <div
                className={`collapse ${currentPath.includes("/admin/uploads") ? "show" : ""
                  }`}
                id="collapseUploads"
              >
                <nav className="sb-sidenav-menu-nested nav">
                  <a
                    className={`nav-link sub_nav_link ${currentPath === "/admin/uploads/view" ? "active" : ""
                      }`}
                    href="/admin/uploads/view"
                  >
                    Upload Zips
                  </a>

                  <a
                    className={`nav-link sub_nav_link ${currentPath ===
                        "/admin/uploads/download-preview-zip"
                        ? "active"
                        : ""
                      }`}
                    href="/admin/uploads/download-preview-zip"
                  >
                    Download Preview Zip
                  </a>
                </nav>
              </div>

              {/* ================= CUSTOMERS ================= */}
              <a
                className={`nav-link ${currentPath === "/admin/customer/list" ? "active" : ""
                  }`}
                href="/admin/customer/list"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-users" />
                </div>
                Customers
              </a>

              {/* ================= PREORDERS ================= */}
              <a
                className={`nav-link ${currentPath === "/admin/preorder/list" ? "active" : ""
                  }`}
                href="/admin/preorder/list"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-shopping-cart" />
                </div>
                Preorders
              </a>

              {/* ================= ORDERS ================= */}
              <a
                className={`nav-link ${currentPath === "/admin/order/view" ? "active" : ""
                  }`}
                href="/admin/order/view"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-receipt" />
                </div>
                Orders
              </a>

              {/* ================= REPORT ================= */}
              <a
                className={`nav-link ${currentPath === "/admin/report/view" ? "active" : ""
                  }`}
                href="/admin/report/view"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-file-alt" />
                </div>
                Report
              </a>

              {/* ================= WALLET ================= */}
              <a
                className="nav-link collapsed"
                href="#"
                data-toggle="collapse"
                data-target="#collapseWallet"
                aria-expanded={
                  currentPath.includes("/admin/wallet") ? "true" : "false"
                }
                aria-controls="collapseWallet"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-wallet" />
                </div>
                Wallet
                <div className="sb-sidenav-collapse-arrow">
                  <i className="fas fa-angle-down" />
                </div>
              </a>

              <div
                className={`collapse ${currentPath.includes("/admin/wallet") ? "show" : ""
                  }`}
                id="collapseWallet"
              >
                <nav className="sb-sidenav-menu-nested nav">
                  <a
                    className={`nav-link sub_nav_link ${currentPath === "/admin/wallet/list" ? "active" : ""
                      }`}
                    href="/admin/wallet/list"
                  >
                    Wallet Package
                  </a>

                  <a
                    className={`nav-link sub_nav_link ${currentPath === "/admin/wallet/admin-topup"
                        ? "active"
                        : ""
                      }`}
                    href="/admin/wallet/admin-topup"
                  >
                    Add Amount
                  </a>

                  <a
                    className={`nav-link sub_nav_link ${currentPath === "/admin/wallet/transactions"
                        ? "active"
                        : ""
                      }`}
                    href="/admin/wallet/transactions"
                  >
                    Transactions
                  </a>
                </nav>
              </div>

              {/* ================= CONFIG ================= */}
              <a
                className={`nav-link ${currentPath === "/admin/config" ? "active" : ""
                  }`}
                href="/admin/config/view"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-cog" />
                </div>
                Config
              </a>

              {/* ================= OFFERS ================= */}
              <a
                className={`nav-link ${currentPath === "/admin/offer" ? "active" : ""
                  }`}
                href="/admin/offer/view"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tags" />
                </div>
                Offers
              </a>

              {/* ================= SPECIAL PRODUCTS ================= */}
              <a
                className={`nav-link ${currentPath === "/admin/special-product" ? "active" : ""
                  }`}
                href="/admin/special/view"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-star" />
                </div>
                Special Products
              </a>
              {/* Bottom breathing space */}
              <div
                style={{
                  height: "30px",
                  minHeight: "30px",
                  width: "100%",
                }}
              />

            </div>
          </div>
        </nav>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/admin/sidebar/index.js